import { defineMessages } from 'react-intl-next';

export const messages: {
	hideLabelButtonText: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	labelButtonTitle: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	labelPopupTitle: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	labelButtonTitle: {
		id: 'company-hub.company-hub-common.config-panel.content.label-button.title',
		defaultMessage: 'Label',
		description: 'Title for label button in item config panel',
	},
	labelPopupTitle: {
		id: 'company-hub.company-hub-common.config-panel.content.label-button.popup.title',
		defaultMessage: 'Label',
		description: 'Title for label popup in item config panel',
	},
	hideLabelButtonText: {
		id: 'company-hub.company-hub-common.config-panel.content.label-button.popup.hide-label-button.text',
		defaultMessage: 'Hide label',
		description: 'Text for button that hides the label from an item',
	},
});
